import { render, staticRenderFns } from "./ActiveResult.vue?vue&type=template&id=2f3b3343&scoped=true&"
import script from "./ActiveResult.vue?vue&type=script&lang=js&"
export * from "./ActiveResult.vue?vue&type=script&lang=js&"
import style0 from "./ActiveResult.vue?vue&type=style&index=0&id=2f3b3343&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b3343",
  null
  
)

export default component.exports